export default __webpack_public_path__ + "18d4080f6087c09db1ec8363f675e50c.png";